"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorsFactory = exports.DynamicValidators = void 0;
const relative_date_str_1 = require("../utils/relative-date-str");
const additional_insured_validator_1 = require("./additional-insured-validator");
const additional_boaters_validator_1 = require("./additional-boaters-validator");
const base_1 = require("./base");
const date_1 = require("../utils/date");
const lh_layup_validator_1 = require("./lh-layup-validator");
const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const isEmptyValue = (value) => typeof value === 'undefined' ||
    value === null ||
    (typeof value === 'number' && value == 0) ||
    (typeof value === 'string' && value.length === 0);
var DynamicValidators;
(function (DynamicValidators) {
    function validateRelatedQuestions({ model, eventBus, Events }) {
        const dynamicValidators = [
            {
                valid: false,
                questionId: 'Layup1_From',
                relatedQuestionId: 'Layup1_To',
                masterQuestionId: 'layup_info',
                metaData: {
                    minLength: '2 Months',
                },
                validatorFunction: {
                    title: 'minTwoMonthsDifference',
                    validate: (fromQuestionValue, toQuestionValue) => {
                        if (fromQuestionValue && toQuestionValue) {
                            const from = new Date(fromQuestionValue);
                            const to = new Date(toQuestionValue);
                            const differenceInMonths = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
                            // returning true means no error
                            return differenceInMonths >= 2;
                        }
                        return false;
                    },
                },
                eventName: Events.Type.LessThanTwoMonthsLayup,
            },
        ];
        dynamicValidators.forEach((validator) => {
            const questionValue = model.getQuestionById(validator.questionId)?.value;
            const relatedQuestionValue = model.getQuestionById(validator.relatedQuestionId)?.value;
            validator.valid = validator.validatorFunction.validate(questionValue, relatedQuestionValue);
            if (!validator.valid) {
                eventBus().emit(validator.eventName, validator.masterQuestionId || validator.questionId);
            }
        });
        return dynamicValidators;
    }
    DynamicValidators.validateRelatedQuestions = validateRelatedQuestions;
})(DynamicValidators || (exports.DynamicValidators = DynamicValidators = {}));
var ValidatorsFactory;
(function (ValidatorsFactory) {
    function createEmailRule() {
        return (input) => !isEmptyValue(input) && !emailRegexp.test(input)
            ? {
                input,
                message: 'ValidErrEmail',
            }
            : undefined;
    }
    ValidatorsFactory.createEmailRule = createEmailRule;
    function createMinimumLengthRule(min = -1) {
        return (input = '') => (input === null) || (input === undefined) || input.length < min
            ? {
                input,
                message: 'ValidErrMinLength',
                meta: [min],
            }
            : undefined;
    }
    ValidatorsFactory.createMinimumLengthRule = createMinimumLengthRule;
    function createMaximumLengthRule(max = 0, message = 'ValidErrMaxLength') {
        return (input = '') => (input !== null) && (input !== undefined) && (input.length > max)
            ? {
                input,
                message: message,
                meta: [max],
            }
            : undefined;
    }
    ValidatorsFactory.createMaximumLengthRule = createMaximumLengthRule;
    function createMinNumberRule(min = 0) {
        return (input = '') => parseInt(input) < min
            ? {
                input,
                message: 'ValidErrMinNumber',
                meta: [min],
            }
            : undefined;
    }
    ValidatorsFactory.createMinNumberRule = createMinNumberRule;
    function createManufactorYearRule() {
        return (input) => {
            var date = new Date();
            return parseInt(input) > date.getFullYear() + 1
                ? {
                    input,
                    message: 'ValidErrYear',
                }
                : undefined;
        };
    }
    ValidatorsFactory.createManufactorYearRule = createManufactorYearRule;
    function correctBankAccountRoutingNumber() {
        return (input = '') => {
            let res = 0;
            let resTotal = 0;
            const inputArr = input.split('');
            const size = 3;
            let arrayOfArrays = [];
            for (let i = 0; i < inputArr.length; i += size) {
                arrayOfArrays.push(input.slice(i, i + size));
            }
            arrayOfArrays.forEach(el => {
                const elArr = el.split('');
                res = (parseInt(elArr[0]) * 3 + parseInt(elArr[1]) * 7 + parseInt(elArr[2]) * 1);
                resTotal += res;
            });
            return (resTotal % 10) != 0
                ? {
                    input,
                    message: 'Please check the bank routing number.  It doesn\'t seem correct.',
                }
                : undefined;
        };
    }
    ValidatorsFactory.correctBankAccountRoutingNumber = correctBankAccountRoutingNumber;
    function createInNextXDaysRule(from_days, to_days, message = 'ValidErrInNextXDays') {
        return (input) => {
            var from_date = new date_1.DateValue();
            from_date.addDays(from_days);
            var to_date = new date_1.DateValue();
            to_date.addDays(to_days);
            var inputDate = new date_1.DateValue(input);
            if (inputDate < from_date) {
                return {
                    input,
                    message: message,
                    meta: [String(from_days), String(to_days)],
                };
            }
            else if (inputDate > to_date) {
                return {
                    input,
                    message: message,
                    meta: [String(from_days), String(to_days)],
                };
            }
            return undefined;
        };
    }
    ValidatorsFactory.createInNextXDaysRule = createInNextXDaysRule;
    function createExpiredDateRule(message = 'ValidErrExpired') {
        return (input) => {
            var inputDate = new date_1.DateValue(input);
            return inputDate < new date_1.DateValue()
                ? {
                    input,
                    message: message,
                }
                : undefined;
        };
    }
    ValidatorsFactory.createExpiredDateRule = createExpiredDateRule;
    function createPastDateRule(untilDate, message = 'ValidErrPast') {
        const beforeDate = untilDate ? new date_1.DateValue(untilDate) : new date_1.DateValue();
        return (input) => {
            var inputDate = new date_1.DateValue(input);
            return inputDate > beforeDate
                ? {
                    input,
                    message: message,
                }
                : undefined;
        };
    }
    ValidatorsFactory.createPastDateRule = createPastDateRule;
    function createBeforePastDateRule(untilDate, message = 'ValidErrBeforePast') {
        const beforeDate = untilDate ? new date_1.DateValue(untilDate) : new date_1.DateValue();
        return (input) => {
            var inputDate = new date_1.DateValue(input);
            return inputDate < beforeDate
                ? {
                    input,
                    message: message,
                }
                : undefined;
        };
    }
    ValidatorsFactory.createBeforePastDateRule = createBeforePastDateRule;
    function createRegexpRule(tester, message = 'InvalidCustomInput') {
        return (input) => !isEmptyValue(input) && !tester.test(input)
            ? {
                input,
                message,
            }
            : undefined;
    }
    ValidatorsFactory.createRegexpRule = createRegexpRule;
    function createMandatoryRule(message = 'ValidErrMandatory') {
        return (input) => isEmptyValue(input)
            ? {
                input,
                message,
            }
            : undefined;
    }
    ValidatorsFactory.createMandatoryRule = createMandatoryRule;
    function createCheckedRule(message = 'ValidErrChecked') {
        return (input) => input === '$_BOOL_true' ? undefined : { input, message };
    }
    ValidatorsFactory.createCheckedRule = createCheckedRule;
    function createNotOther(message = 'ValidErrNotOther') {
        return (input) => input == 'Other'
            ? {
                input,
                message,
            }
            : undefined;
    }
    ValidatorsFactory.createNotOther = createNotOther;
    function createRuleFromAlias(alias, questionRaw) {
        try {
            const [name, meta, err] = alias.split('::');
            switch (name) {
                case 'layupValidator':
                    return (0, lh_layup_validator_1.LayupValidator)(questionRaw);
                case 'additionalInsuredValidator':
                    return (0, additional_insured_validator_1.AdditionalInsuredValidator)(questionRaw);
                case 'additionalBoatersValidator':
                    return (0, additional_boaters_validator_1.AdditionalBoatersValidator)(questionRaw);
                case 'digitsOnly':
                    return createRegexpRule(/^\d+/, 'ValidErrNumeric');
                case 'phone':
                    //eslint-disable-next-line no-useless-escape
                    return createRegexpRule(/^\+\d{1,4}\ {0,1}\d{6,}/);
                case 'us-phone':
                    //eslint-disable-next-line no-useless-escape
                    return createRegexpRule(/^\+\d{1,4}\ {0,1}[1-9]\d{9,}/, 'ValidErrInvalidPhoneStartWith0');
                case 'us-phone-len':
                    return createMaximumLengthRule(13, 'ValidErrInvalidPhone');
                case 'optional-phone':
                    //eslint-disable-next-line no-useless-escape
                    return createRegexpRule(/^(\+\d{1,4})?\ ?(\d{6,})?$/);
                case 'full-name':
                    return createRegexpRule(/\w+\s\w+/, 'ValidErrInvalidName');
                case 'initials':
                    return createRegexpRule(/^\s*[a-zA-Z]\s*[a-zA-Z]\s*$/, 'ValidErrInvalidInitials');
                case 'email':
                    return createEmailRule();
                case 'minlength':
                    return createMinimumLengthRule(parseInt(meta));
                case 'maxlength':
                    return createMaximumLengthRule(parseInt(meta));
                case 'mandatory':
                    return createMandatoryRule(err);
                case 'checked':
                    return createCheckedRule(err);
                case 'insurance-start-date':
                    return createInNextXDaysRule(2, 30);
                case 'insurance-start-date-agent':
                    return createInNextXDaysRule(0, 30);
                case 'insurance-start-date-renew':
                    //TBD change to 75
                    return createInNextXDaysRule(0, 175);
                case 'before-past-date':
                    return createBeforePastDateRule(meta ? (0, relative_date_str_1.relativeDateFromString)(meta) : '', err);
                case 'past-date':
                    return createPastDateRule(meta ? (0, relative_date_str_1.relativeDateFromString)(meta) : '', err);
                case 'expired-date':
                    return createExpiredDateRule();
                case 'minNumber':
                    return createMinNumberRule(parseInt(meta));
                case 'manufacturYear':
                    return createManufactorYearRule();
                case 'correct-bank-routing-number':
                    return correctBankAccountRoutingNumber();
                case 'not-other':
                    return createNotOther();
                default:
                    return undefined;
            }
        }
        catch {
            return undefined;
        }
    }
    ValidatorsFactory.createRuleFromAlias = createRuleFromAlias;
    function createFromRaw(raw) {
        return (raw.validators || [])
            .map((alias) => ValidatorsFactory.createRuleFromAlias(alias, raw))
            .filter(Boolean)
            .reduce((validator, rule) => {
            return validator.addRule(rule);
        }, new base_1.BaseValidator());
    }
    ValidatorsFactory.createFromRaw = createFromRaw;
})(ValidatorsFactory || (exports.ValidatorsFactory = ValidatorsFactory = {}));
